import { createDomainApi } from '@skylabs-digital/react-proto-kit';
import { z } from 'zod';

export const knownTenantSchema = z.object({
  tenantId: z.string(),
  notifications: z.number(),
});
export type KnownTenant = z.infer<typeof knownTenantSchema>;

/**
 * Tenants que noten vio para la app seleccionada. NO es el padrón de idachu:
 * un tenant sin tráfico ni preferencias no aparece, por eso los pickers dejan
 * escribir un id a mano igual.
 */
export const tenantsApi = createDomainApi('tenants', knownTenantSchema);
